import Image from "next/image"
import Link from "next/link"
const { DateTime } = require("luxon");
import { supabase } from "../../utils/supabaseClient"
import { Check } from "react-bootstrap-icons"
import { cloudfront } from "../../config"
import Layout from '../../components/Layouts/homeLayout'
import { useAuth, AuthProvider } from "../../contexts/Auth"
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import Meta from "../../components/Meta";

  export async function getStaticProps() {
      //the article
      const {data, error} = await supabase
        .from('main_article')
        .select('*, profile(name, user_image)')
        .match({status:"live"})
        .order('date_published', { ascending: false })
        

      error && console.log(error)

      const articles = data

    return {
        props: {
            articles
        }
        //revalidate ??
    }
  }

  const features = ["Scheduling pages to collect bookings",
 "Customizable video chat",
  "Automatic email reminders" ,
  "Upload logo once to brand all assets (scheduling, video chat, email reminders)",
   "Automatic cancellation and rescheduling",
    "Goal tracking",
     "Client Portal"]

export default function Blog({articles}) {
    return (
        <div className="bg-slate-200/50 pb-36 h-full pt-5">
          <Meta
            title="Plaza Blog Articles"
            description="Find helpful information on how to recover from burnout or grow as an online coach"
          />
          <div className=" text-left overflow-hidden py-20 flex flex-col items-baseline bg-slate-200/80 ">
            <div className="px-4  w-3/4 mx-auto z-20 ">

            <h1 className="font-extrabold text-4xl text-slate-800 ">Blog Articles</h1>
            <p className="font-extrabold text-xl text-slate-500 ">Burnout recovery and coaching resources</p>

            </div>
          </div>
          <div>
            {/* //Cover image here */}
          </div>
          <div className="absolute top-0 mt-36 h-full w-full overflow-hidden z-10" aria-hidden="true">
          <div className="relative h-full overflow-hidden">
            <svg
              className="absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)" />
            </svg>
            <svg
              className="absolute overflow-hidden left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="d2a68204-c383-44b1-b99f-42ccff4e5365"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#d2a68204-c383-44b1-b99f-42ccff4e5365)" />
            </svg>
            
          </div>
        </div>
          <div className=" pt-5 text-left pb-48 z-20 relative">
            <div className="flex flex-wrap w-3/4 mx-auto justify-evenly">
                {articles.map(article => (
                    <div key={article.id} className="md:w-[30%] sm:w-[45%] p-5 m-2 rounded-lg shadow border bg-white">
                    <Link href={`/blog/${article.slug}`}>
                        <a>
                         <p className="italic text-slate-500 text-sm">{DateTime.fromISO(article.date_published).toFormat("DDD")}</p>
                         {article.cover_image && 
                    <div className="">

                          <Image
                          src={"https://d28zq0um2frnpx.cloudfront.net/media/article_images/" + article.cover_image}
                          height={300}
                          width={900}
                          alt={article.cover_image_alt}
                          className={"rounded-lg"}
                          objectFit="cover"
                      />
                      </div>
              }
                        <h3 className="text-slate-800 text-xl font-bold mb-2">{article.title}</h3>
                       
                        <p className="text-slate-600 text-md">{article.content.substring(0,130).replace(/<[^>]*>?/gm, '')}</p>
                        </a>
                        </Link>
                    </div>

                ))}

            </div>
            

              {/* CTA */}
            {/* <div className="bg-white rounded-lg shadow-lg mt-20 border flex flex-col sm:flex-row justify-between">
              <div className="p-10 shadow z-10 w-full sm:w-[60%] text-center">
              <h2 className="text-slate-800 font-bold text-2xl">Get started today with Plaza</h2>
                <p className="text-slate-800">Everything you need for your virtual coaching business</p>
                <div className="flex space-x-3 mt-4 mx-auto w-72 ">
                  <Link href="/register">
                  <a
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700"
                  >Get Started</a>
                </Link>
                <Link href="/register">
                  <a
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-slate-700 text-white shadow-lg shadow-slate-500/50 bg-slate-600"
                  >Book a Demo</a>
                </Link>

                </div>
                <div className="my-2 mx-auto text-center">
    
                <Image
                     objectFit={'contain'}
                     src={`${cloudfront}/static/branding_group.png`}
                     width={500}
                     height={300}
                     alt="Plaza for video consultations"
                 
                 />
                  </div>
   
                
    



              </div>
              <div className="space-y-5 p-10 bg-slate-100 w-full sm:w-[40%]">
                {features.map(string => (
                  <div key={string} className="flex justify-start items-center space-x-4">
                    <div className=""><Check className="bg-green-400 text-white rounded-full"/></div>
                    <p className="text-slate-700 font-semibold"  key={string}>{string}</p>
                  </div>
                ))}
              </div>
       
            </div> */}
          </div>
          <div className="w-full flex justify-center">
            <p className="text-slate-500">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>

          </div>
        </div>
    );
}

const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {'zIndex':'9999'},
    // you can also just use 'fade'
    transition: transitions.FADE,
  }
  
  Blog.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
  }
  